import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings, TextFilter } from '@progress/kendo-react-data-tools'
import { MarketingCampaignFilterKey } from 'api/Trading-Accounts/Types/MarketingCampaignDto'
import { MarketingCampaignStatus } from 'api/Trading-Accounts/Types/MarketingCampaignStatus'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'
import { getEnumEntries } from 'utils/getEnumEntries'

import { useAppSelector } from '../../store'
import { CustomDateFilter } from './common.filter'
import { SelectFilter } from './SelectFilter'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

const CampaignTypeFilter = ({ filter, onFilterChange }: FilterProps) => {
  const campaignTypes = useAppSelector((state) => state.tradingAccounts.campaignTypes)
  const data = campaignTypes.map((x) => ({
    id: x.id.toString(),
    label: x.name,
    value: x.id,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

const CampaignCalculationTypeFilter = ({ filter, onFilterChange }: FilterProps) => {
  const campaignCalculationTypes = useAppSelector(
    (state) => state.tradingAccounts.campaignCalculationTypes
  )
  const data = (campaignCalculationTypes || []).map((x) => ({
    id: x.id.toString(),
    label: x.name,
    value: x.id,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

const CampaignStatusFilter = ({ filter, onFilterChange }: FilterProps) => {
  const data = getEnumEntries(MarketingCampaignStatus).map(([key, value]) => ({
    id: value.toString(),
    label: key,
    value: value,
  }))

  return <SelectFilter filter={filter} onFilterChange={onFilterChange} data={data} />
}

export const getWalletFilterFields = (): FieldSettings[] => [
  {
    name: MarketingCampaignFilterKey.name,
    label: 'Name',
    filter: TextFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.startsWithOperator,
        operator: GridFilterOperatorEnum.startsWithOperator,
      },
    ],
  },
  {
    name: MarketingCampaignFilterKey.type,
    label: 'Type',
    filter: CampaignTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: MarketingCampaignFilterKey.calculationType,
    label: 'Calculation Type',
    filter: CampaignCalculationTypeFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: MarketingCampaignFilterKey.from,
    label: 'Start Date',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: MarketingCampaignFilterKey.to,
    label: 'End Date',
    filter: CustomDateFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOperator,
        operator: GridFilterOperatorEnum.afterOperator,
      },
      {
        text: GridFilterOperatorNameEnum.afterOrEqualOperator,
        operator: GridFilterOperatorEnum.afterOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOrEqualOperator,
        operator: GridFilterOperatorEnum.beforeOrEqualOperator,
      },
      {
        text: GridFilterOperatorNameEnum.beforeOperator,
        operator: GridFilterOperatorEnum.beforeOperator,
      },
    ],
  },
  {
    name: MarketingCampaignFilterKey.status,
    label: 'Contests Status',
    filter: CampaignStatusFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
